export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidPin = (pin) => {
  const pinRegex = /^\d{6}$/;
  return pinRegex.test(pin);
};

export const isValidPhoneNumber = (phoneNumber) => {
  console.log(phoneNumber);
  const phoneRegex = /^\d{10}$/;
  return phoneRegex.test(phoneNumber);
};

export const isValidOTP = (otp) => {
  const pinRegex = /^\d{6}$/;
  return pinRegex.test(otp);
};

export const isValidAadhar = (aadharNumber) => {
  const pinRegex = /^\d{12}$/;
  const maskedRegex = /^XXXXXXXX\d{4}$/;
  return pinRegex.test(aadharNumber) || maskedRegex.test(aadharNumber);
};
